<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active w-35pc" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'select_passenger_load' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate}}
                </button>
            </div>
        </header>
        
            <div class="eod-panel-body" id="rowHover">
                <div class="block float-left w-100pc padding-top-25 padding-left-10">
                    <div class="row" *ngFor="let item of inputData;" (click)="fnSelectPassengerLoad(item)">
                        <div class="col-lg-6 padding-left-0" *ngIf="item.allowanceId<5">
                            <span class="align-middle d-block">
                                <img alt="" src="{{item.allowanceIcon}}" style="height: 40px;width: auto;">
                            </span>
                        </div>
                        <div class="col-lg-6 padding-right-0 text-right align-middle fw-700 lH-35"
                            *ngIf="item.allowanceId<5">
                            <span class="padding-right-10" *ngIf="item.selected">
                                <i class="f-20 color-green fa fa-check align-middle"></i>
                            </span>
                            {{item.allowanceDescription}}
                        </div>
                    </div>
                    <hr class="border-top margin-0 padding-0" *ngIf="fnCheckForItems()"
                        style="margin:10px 0 !important">
                    <div class="row " *ngFor="let item of inputData;" (click)="fnSelectPassengerLoad(item)">
                        <div class="col-lg-6 padding-left-0" *ngIf="item.allowanceId>4">
                            <span class="align-middle d-inline-block position-relative ">
                                <img alt="" src="{{item.allowanceIcon}}" style="height: 40px;width: auto;">
                            </span>
                        </div>
                        <div class="col-lg-6 padding-right-0 text-right align-middle fw-700 lH-35"
                            *ngIf="item.allowanceId>4">
                            <span class="padding-right-10" *ngIf="item.selected">
                                <i class="f-20 color-green fa fa-check align-middle"></i>
                            </span>
                            {{item.allowanceDescription}}
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>